import { ButtonBaseProps } from "@material-ui/core/ButtonBase";
import Tab, { TabProps } from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { withStyles } from "@material-ui/core/styles";
import React from "react";

export const CohereTabs = withStyles((theme) => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  indicator: {
    backgroundColor: theme.palette.primary.main,
    height: 4,
  },
  flexContainer: {
    gap: theme.spacing(7),
    height: "100%",
  },
}))(Tabs);

export const CohereTab = withStyles((theme) => ({
  root: {
    padding: 0,
    // Forces tab width to hug content
    minWidth: 0,
  },
  wrapper: {
    // Ideally we could use the Tab iconPosition prop, but these styles are a workaround
    display: "flex",
    flexDirection: "row-reverse",
    alignItems: "center",
    gap: theme.spacing(0.5),
    margin: 0,
    "& > *": {
      // wrapper children come with margin-bottom by default. Regular selector doesn't work on its own, hence !important
      marginBottom: "0 !important",
    },
  },
  labelIcon: {
    minHeight: "unset",
  },
}))(
  (
    props: TabProps & ButtonBaseProps & { children?: React.ReactNode } // Allow children component
  ) => {
    return <Tab disableRipple {...props} />;
  }
);
